module.exports = __webpack_public_path__ + "static/img/知识产权模块.d684dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/知识产权模块.png
// module id = Q+jv
// module chunks = 1